import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Link, useHistory } from 'react-router-dom';
import { Icon, Loader, Modal } from 'semantic-ui-react';
import SearchSection from './SearchSection';
import { Order } from '../../types';
import { ArrowIcon } from '../../../components/icons';
import { useAddProperty } from './AddPropertyContext';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;
const Close = styled.button`
  display: flex;
  justify-content: flex-end;
  padding: 15px;
  background-color: #fff;
  border: none;
  cursor: pointer;
`;
const ActualContent = styled.div`
  padding: 0 35px;
`;
const Header = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #4d4e4d;
  border-bottom: 1px solid #e5e5ea;
  padding: 0px 35px 16px 35px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 9px;
  justify-content: flex-end;
  border-top: 1px solid #e5e5ea;
  padding-top: 24px;
  padding-bottom: 24px;
  margin-top: 56px;
`;

const CancelButton = styled.button`
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  color: #444444;
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  width: 127px;
  height: 47px;
  cursor: pointer;
`;
const Children = styled.div`
  margin-top: 24px;
`;
const ConfirmButton = styled.button`
  background: #444;
  border: 1px solid #444;
  border-radius: 5px;
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  width: 127px;
  height: 47px;
  cursor: pointer;
  margin-right: 35px;
`;
interface Props {
  open: boolean;
  onClose: any;
  onCloseSearch: any;
  order: Order;
  getOrderDetails: () => any;
}

const AddSearchModal = (props: Props) => {
  const { onCancel, submitting, onSubmit } = useAddProperty();
  return (
    <Modal open={props.open} style={{ width: 760, zIndex: 500 }} onClose={props.onClose}>
      <ModalContent>
        <ArrowIcon
          style={{ transform: 'rotate(180deg)', cursor: 'pointer', position: 'absolute', top: 16, left: 8 }}
          onClick={props.onCloseSearch}
        />
        <Close onClick={props.onClose}>
          <Icon name="close" />
        </Close>
        <Header>Add Search</Header>
        <ActualContent>
          <SearchSection order={props.order} />
        </ActualContent>
        <ButtonContainer>
          <CancelButton
            onClick={() => {
              props.onClose();
              onCancel();
            }}
          >
            Cancel
          </CancelButton>
          <ConfirmButton onClick={async() => {
            await onSubmit(props.order.id);
            props.onClose();
            props.onCloseSearch();
            props.getOrderDetails();
            }}>
            {submitting ? <Loader style={{ margin: '0 auto' }} size="mini" inline="centered" /> : 'Save'}
          </ConfirmButton>
        </ButtonContainer>
      </ModalContent>
    </Modal>
  );
};

export default AddSearchModal;
